import {WidgetData} from '../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../core/shared/misc/sorting';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../core/shared/helper/widget-function-call-back-create';

/**
 * Alias of the "Tickettypen" child widget of a case type (CONFIG-011: exactly ONE alias across every
 * state of the widget).
 */
export const CW_CASE_TYPE_TICKET_TYPE_WIDGET_ALIAS = 'config.cw.CwCaseTypeTicketType.widget';

/**
 * Builds the "Tickettypen" child table of one {@code cw.CwCaseType} ([CW-TICKET-TYPES]) — the ticket
 * types a Vorgang of that type may raise, each with its internal type:
 * <ul>
 *   <li><b>Nachbearbeitung</b> — Rückfrage tickets; they drive the Rückfragen-Status and the locks of
 *       the Vorgang.</li>
 *   <li><b>Sonstiges</b> — every other ticket; it only feeds "Niedrigster Status sonstige Tickets".</li>
 * </ul>
 *
 * Each row also carries the two tm object roles the Vorgang and the customer are linked into; the
 * Vorgang role must be a main-object role, otherwise the ticket does not show up in the Vorgang's
 * ticket list (config check CWCHK-H4).
 *
 * Mirrors {@code buildCwRequestTypeTicketTypeWidget}. TRAP CONFIG-012: the parent FK is pre-set on
 * CREATE via {@code onFunctionCreateNew}.
 *
 * @param caseTypeId id of the selected parent {@code cw.CwCaseType}.
 */
export function buildCwCaseTypeTicketTypeWidget(caseTypeId: number): WidgetData {
    /**
     * AI:
     * Status: "in progress"
     * Type: Widget
     * SubType: Runtime
     * Reason: Child table of one CwCaseType's Tickettypen (internal type Nachbearbeitung / Sonstiges),
     *   parent FK pre-set on CREATE via WidgetFunctionCallBackCreate (CONFIG-012).
     */
    const widgetData = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
        CW_CASE_TYPE_TICKET_TYPE_WIDGET_ALIAS,
        'Tickettypen',
        'cw.CwCaseTypeTicketType',
        [FilterCriteria.create('e.caseTypeId', FilterCriteria.cOperatorEqual, caseTypeId)],
        [new Sorting('e.internalType', true), new Sorting('e.sortOrder', true)]
    );
    widgetData.noDataText = 'Keine Tickettypen für diesen Vorgangstyp konfiguriert';

    const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'caseTypeDtoId', fieldValue: caseTypeId}];
    widgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

    return widgetData;
}
